import { resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { class: "n-page__tiles" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_CaseClusterItem = _resolveComponent("CaseClusterItem")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_ClusterWizard = _resolveComponent("ClusterWizard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FilterSection, {
      filter: _ctx.module.filter,
      schemeSmall: _ctx.smallFilterLayout,
      schemeLarge: _ctx.largeFilterLayout,
      hasPinnedFields: "",
      defaultPinnedFields: _ctx.defaultPinnedFields
    }, {
      small: _withCtx(() => []),
      _: 1
    }, 8, ["filter", "schemeSmall", "schemeLarge", "defaultPinnedFields"]),
    _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clusters, (item) => {
        return (_openBlock(), _createBlock(_component_CaseClusterItem, {
          key: item.id,
          item: item,
          onAction: (type) => _ctx.actionHandler(item, type),
          onCardClick: _cache[0] || (_cache[0] = (cardItem) => _ctx.actionHandler(cardItem, 'ShowCard')),
          objects: "faces",
          "cluster-selected": item.id === _ctx.currentSidebarItemId,
          "show-name": true,
          "show-role": true,
          "show-events-count": true,
          "show-card": !_ctx.isParticipantsPage,
          "show-confidence": !_ctx.isParticipantsPage,
          "show-acknowledge": !_ctx.isParticipantsPage && item.matched_card !== null
        }, null, 8, ["item", "onAction", "cluster-selected", "show-card", "show-confidence", "show-acknowledge"]))
      }), 128))
    ]),
    _createVNode(_component_InfiniteScroll, {
      filters: _ctx.module.filter.current,
      itemsHash: _ctx.module.items.length,
      onLoadMore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.module.append()))
    }, null, 8, ["filters", "itemsHash"]),
    (_ctx.wizardClusterEnabled)
      ? (_openBlock(), _createBlock(_component_ClusterWizard, {
          key: 0,
          caseCluster: _ctx.currentCaseCluster,
          disabled: _ctx.isCaseArchived,
          onClose: _cache[2] || (_cache[2] = ($event: any) => {
      _ctx.wizardClusterEnabled = false;
      _ctx.$emit('refresh');
    })
        }, null, 8, ["caseCluster", "disabled"]))
      : _createCommentVNode("", true)
  ], 64))
}